import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModulesFacade } from '@library/store/modules/modules.facade';
import { Room } from '@library/store/rooms/rooms.interface';
import { ControlPageCardService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/control-page-card.service';
import { SUPPORTED_CONTROL_ENERGY_MODULES, SUPPORTED_CONTROL_WEATHER_MODULES } from '@pages/control-page/control-page.const';
import { firstValueFrom, switchMap } from 'rxjs';

@Component({
  selector: 'app-cp-compare-sidebar-rooms',
  templateUrl: './cp-compare-sidebar-rooms.component.html',
  styleUrls: ['./cp-compare-sidebar-rooms.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpCompareSidebarRoomsComponent {

  rooms$ = this.controlPageCardService.rooms$.pipe(
    switchMap(async rooms => {
      const modules = await firstValueFrom(this.modulesFacade.currentHomeModules$);

      const roomIds = modules
        .filter(module => ([
          ...SUPPORTED_CONTROL_WEATHER_MODULES,
          ...SUPPORTED_CONTROL_ENERGY_MODULES,
        ].includes(module.type)))
        .map(module => module.room_id);

      return rooms.filter(room => roomIds.includes(room.id));
    }),
  );

  trackById = (index: number, room: Room) => room.id;

  constructor(
    private controlPageCardService: ControlPageCardService,
    private modulesFacade: ModulesFacade,
  ) { }

}
